<template>
    <!--食堂采购-->
    <div class="view" :style="{paddingTop:navbarheight}">
        <div class="content">
            <my-top title="食堂采购" lefttext="返回" @leftclick="togo('/application/canteen/purchase')" :righttext="!readonly ? subTit : ''" @rightclick="handleValidator" ></my-top>
            <Form ref="form">
                <cell-group class="baseInfo">
                    <cell title="单位" :value="form.unitName"></cell>
                    <cell class="timeCell" is-link title="采购日期" :value="form.createTime" @click="visible= ableVisible ? !ableVisible : !visible"></cell>
                </cell-group>
                <cell-group title="按采购种类填写（单位：元）" class="baseInfo">
                    <field @blur="handleType" :formatter="formatter" :rules="[{required: true}]" :readonly="readonly" v-model="formType.vegetables" label="荤类（荤素）" type="number" placeholder="请输入"/>
                    <field @blur="handleType" :formatter="formatter"  :rules="[{required: true}]" :readonly="readonly" v-model="formType.egg" label="蛋类" type="number" placeholder="请输入" />
                    <field @blur="handleType" :formatter="formatter" :rules="[{required: true}]" :readonly="readonly" v-model="formType.oil" label="食用油" type="number" placeholder="请输入" />
                    <field @blur="handleType" :formatter="formatter" :rules="[{required: true}]" :readonly="readonly" v-model="formType.rice" label="大米" type="number" placeholder="请输入" />
                    <field @blur="handleType" :formatter="formatter" :rules="[{required: true}]" :readonly="readonly" v-model="formType.flour" label="面粉" type="number" placeholder="请输入" />
                    <field @blur="handleType" :formatter="formatter" :rules="[{required: true}]" :readonly="readonly" v-model="formType.seasoning" label="佐料" type="number" placeholder="请输入" />
                    <field @blur="handleType" :formatter="formatter" :rules="[{required: true}]" :readonly="readonly" v-model="formType.milk" label="水果奶类" type="number" placeholder="请输入" />
                    <field @blur="handleType" :formatter="formatter" :rules="[{required: true}]" :readonly="readonly" v-model="formType.other" label="其他" type="number" placeholder="请输入" />
                    <field v-model="form.totalMoney" label="合计" placeholder="0" readonly/>
                </cell-group>
                <cell-group title="按采购供应商填写（单位：元）" class="cellgroup">
                    <field @blur="handleSupplier" :formatter="formatter" :rules="[{required: true}]" :readonly="readonly" v-for="(item, n) in form.officeCanteenProcurementSuppilers" v-model="item.value" :label="item.name" :key="n" type="number" placeholder="请输入" />
                    <field v-model="form.supMoney" label="合计" placeholder="0" readonly/>
                </cell-group>
                <cell-group title="附件" class="cellgroup">
                    <cell>
                        <template #title>
                            <div><span style="color: red">*</span> 购买清单</div>
                        </template>
                        <template #label>
                            <UploadList :disabled='disabled'
                                        :imageList="fileForm.fileList"
                                        v-on:imageListChange="qualifiedImgListChange($event, '1')"
                                        v-on:handleUploadStatus="UploadStatusChange($event, i, '1')"></UploadList>
                            <div v-if="fileForm.UploadError" style="color: #f00">请上传图片</div>
                        </template>
                    </cell>
                    <cell>
                        <template #title>
                            <div>检疫证明</div>
                        </template>
                        <template #label>
                            <UploadList :disabled='disabled'
                                        :imageList="fileProve.fileList"
                                        v-on:imageListChange="qualifiedImgListChange($event, '2')"
                                        v-on:handleUploadStatus="UploadStatusChange($event, i, '2')"></UploadList>
                            <div v-if="fileProve.UploadError" style="color: #f00">请上传图片</div>
                        </template>
                    </cell>
                    <cell>
                        <template #title>
                            <div>农残检查</div>
                        </template>
                        <template #label>
                            <UploadList :disabled='disabled'
                                        :imageList="fileDetect.fileList"
                                        v-on:imageListChange="qualifiedImgListChange($event, '3')"
                                        v-on:handleUploadStatus="UploadStatusChange($event, i, '3')"></UploadList>
                            <div v-if="fileDetect.UploadError" style="color: #f00">请上传图片</div>
                        </template>
                    </cell>
                </cell-group>
            </Form>
        </div>
        <Popup v-model="visible" position="bottom">
            <datetime-picker
                    v-model="meetTime"
                    type="date"
                    title="选择年月日"
                    :max-date="maxDate"
                    @confirm="handleDate"
                    @cancel="visible=false"
            />
        </Popup>
    </div>
</template>

<script>
    import {Cell, CellGroup, DatetimePicker, Dialog, Field, Form, Icon, Popup} from 'vant';
    import UploadList from "@components/UploadListVant/index.vue";
    import application from '@api/application';

    export default {
        name: "dinersForm",
        components: {Cell, CellGroup, Field, Icon, DatetimePicker, Popup, UploadList,Form,Dialog},
        data(){
            return{
                readonly:this.$route.query.readonly || false,
                disabled:this.$route.query.readonly, //图片是否上传
                visible:false,
                ableVisible: true,
                subBtn:true,
                subTit:'提交',
                confirmDisabled:true,
                maxDate:new Date(),
                listId:this.$route.query.listId,
                purchaseTime: this.$route.query.purchaseTime,
                fileForm:{
                    fileList:[],
                    images:[],
                    UploadError:false,
                    uploadStatus: false,
                },
                fileProve:{
                    fileList:[],
                    images:[],
                    UploadError:false,
                    uploadStatus: false,
                },
                fileDetect:{
                    fileList:[],
                    images:[],
                    UploadError:false,
                    uploadStatus: false,
                },
                formType:{
                    vegetables: null, //荤菜（素菜）
                    egg: null, //蛋类
                    flour: null, //面粉
                    milk: null, //水果奶类
                    oil: null, //食用油
                    rice: null, //大米
                    seasoning: null, //佐料
                    other: null, //其他
                },
                meetTime: new Date(),
                form:{
                    createTime: this.formatDate(new Date()),
                    unitId: JSON.parse(localStorage.getItem("vuex")).user.company.id,
                    unitName: JSON.parse(localStorage.getItem("vuex")).user.company.name,
                    orgId: JSON.parse(localStorage.getItem("vuex")).user.company.deptId,
                    totalMoney: 0, //采购种类合计’
                    supMoney: 0, //采购供应商合计
                    officeCanteenProcurementSuppilers:[], //食堂采购采购供应商
                    purchaseFileVOS:[], //购买清单文件
                    quarantineFileVOS:[], //检疫证明文件
                    residuesFileVOS:[], //农残检测文件
                }
            }
        },
        methods: {
            formatter(value) {
                // 过滤输入的数字
                if(value && value >= 0){
                    return value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
                }else {
                    return null
                }
            },
            /**
             * 供应商合计
             **/
            handleSupplier(){
                let supMoney =0;
                this.form.officeCanteenProcurementSuppilers.map(item => {
                    if(item.value){
                        supMoney += parseFloat(item.value)
                    }
                })
                this.form.supMoney = supMoney.toFixed(2)
            },
            /**
             * 采购种类合计
             **/
            handleType(e){
                let totalMoney=0;
                let arr = [];
                for(var i in this.formType){
                    arr.push(this.formType[i]);
                }
                arr.map((item, n) => {
                    if(item){
                        totalMoney += parseFloat(item)
                    }
                })
                this.form.totalMoney = totalMoney.toFixed(2)
            },
            /**
             * 选择采购日期
             **/
            handleDate(e){
                this.form.createTime = this.formatDate(e);
                this.visible = false;
                this.handleSureDate(e)
            },
            handleSureDate(e){
                let id;
                if(e){
                    id = this.formatDate(e)
                }else {
                    id = this.formatDate(new Date())
                }
                let form ={
                    id:id,
                    orgId: JSON.parse(localStorage.getItem("vuex")).user.company.deptId,
                }
                application.getOfficeCanteenProcurementByTime(form).then(res => {
                    //0:未采集；1：已采集
                    if(res.code == 0){
                        if(res.data.time == 1){
                            this.readonly = true;
                            Dialog.confirm({
                                message: '该日期已提交数据，不可重复提交',
                            })
                        }else if(res.data.time == 0) {
                            this.readonly = false;
                        }
                    }
                })
            },
            /**
             * 表单必填验证
             **/
            handleValidator(){
                if(!this.subBtn){
                    this.$toast('正在提交，请稍后再试！');
                    return false
                }
                //种类金额验证是否填写
                for(let i in this.formType){
                    if(!this.formType[i]){
                        this.$toast('请填写采购种类金额！');
                        return false
                    }
                }
                //供应商金额是否填写
                let status=true,
                    num = this.form.officeCanteenProcurementSuppilers.length;
                for(let i = 1 ; i < num ; i++){
                    if(!this.form.officeCanteenProcurementSuppilers[i].value){
                        this.$toast('请填写供应商采购金额！');
                        status = false;
                        break;
                    }
                }
                if(!status){
                    this.$toast('请完成供应商采购金额填写！');
                    return false
                }
                //文件是否上传验证
                this.form.purchaseFileVOS=this.fileForm.fileList;
                this.form.quarantineFileVOS=this.fileProve.fileList;
                this.form.residuesFileVOS=this.fileDetect.fileList;
                if(this.form.purchaseFileVOS.length===0){
                    this.$toast('请上传购买清单文件！');
                    return false
                }
                // else if(this.form.quarantineFileVOS.length===0){
                //     this.$toast('请上传检疫证明文件！');
                //     return false
                // }else if(this.form.residuesFileVOS.length===0){
                //     this.$toast('请上传农残检查文件！');
                //     return false
                // }
                //确认金额是否一致
                let msg = '',
                    moneyStatus =true;
                if(this.form.supMoney !==this.form.totalMoney){
                    moneyStatus = true;
                    msg='按采购种类和按采购供应商的合计金额不一致，请检查数据填写是否正确。';
                }else {
                    moneyStatus = false;
                    msg=`请确认采购金额`+this.form.totalMoney+`元，提交后，不能再次修改。`;
                }
                Dialog.confirm({
                    message: msg,
                }).then(() => {
                    if(!moneyStatus){
                        this.handleSubmit()
                    }
                })
            },
            /**
             * 提交表单
             * @param $event
             */
            handleSubmit(){
                this.subBtn = false;
                this.subTit = '正在提交';
                this.form.meetTime = this.formatDate(this.meetTime);
                application.getInsertCanteenSelective({...this.form, ...this.formType}).then(res => {
                    this.$router.push({
                        path: '/application/canteen/purchase',
                    });
                    this.subTit = '提交';
                    this.subBtn = true;
                }).catch(err=>{
                    this.subTit = '提交';
                    this.subBtn = true;
                })
            },
            /**
             * 完成图片
             * @param $event
             * num 购买清单：1， 检疫证明：2， 农残检测 3
             */
            qualifiedImgListChange($event, num) {
                if(num == '1'){
                    this.fileForm.fileList = $event;
                    if(this.fileForm.fileList){
                        this.UploadError = false
                    }
                    this.fileForm.images = $event.map((item) => {
                        return item.commonId;
                    });
                    this.fileForm.uploadStatus=false
                }else if(num == '2'){
                    this.fileProve.fileList = $event;
                    if(this.fileProve.fileList){
                        this.UploadError = false
                    }
                    this.fileProve.images = $event.map((item) => {
                        return item.commonId;
                    });
                    this.fileProve.uploadStatus=false
                }else if(num == '3'){
                    this.fileDetect.fileList = $event;
                    if(this.fileDetect.fileForm.fileList){
                        this.UploadError = false
                    }
                    this.fileDetect.images = $event.map((item) => {
                        return item.commonId;
                    });
                    this.fileDetect.uploadStatus=false
                }
            },

            //上传图片状态
            UploadStatusChange($event, i, num){
                if(num == '1'){
                    this.fileForm.uploadStatus=$event;

                }else if(num == '2'){
                    this.fileProve.uploadStatus=$event;

                }else if(num == '3'){
                    this.fileDetect.uploadStatus=$event;

                }
            },
            /**
             * 获取采购供应商数据
             **/
            handleCanteen(){
                let form={
                    id:JSON.parse(localStorage.getItem("vuex")).user.company.id,
                    supId: '1' //1：食堂采购；2：食堂考核、用餐评价、用餐人数
                }
                application.getOfficeCanteenByOrgId(form).then(res =>{
                    this.form.officeCanteenProcurementSuppilers = res.data
                })
            },
            /**
             * 获取食堂采购信息
             **/
            handleCanteenInfo(){
                application.getOfficeCanteenProcurementById({id:this.listId}).then(res =>{
                    let data = res.data;
                    this.fileForm.fileList=data.purchaseFileVOS;
                    this.fileProve.fileList=data.quarantineFileVOS;
                    this.fileDetect.fileList=data.residuesFileVOS;
                    for(var i in this.formType){
                        this.formType[i] = data[i]
                    }
                    for(var i in this.form) {
                        this.form[i] = data[i]
                    }
                })
            }
        },
        mounted(){
            if(this.readonly){
                // 从详情进入，则不能切换采购日期；
                this.ableVisible = true;
                this.handleCanteenInfo()
            }else {
                // 提交食堂采购进入，可切换采购日期；
                this.ableVisible = false;
                this.handleCanteen()
                this.handleSureDate()
            }
        }
    }
</script>

<style lang="scss" scoped>
    ::v-deep .van-cell-group__title{
        background-color: #f2f2f2;
    }
    ::v-deep .van-field__label{
        flex: 1;
    }
    .baseInfo{
        ::v-deep .van-cell__title{
            flex: 0.5;
        }
        .timeCell{
            ::v-deep .van-icon{
                padding-top: 5px;
            }
        }
    }
    ::v-deep .van-field__control{
        text-align: right;
    }
    ::v-deep .navbar .van-nav-bar__right .van-nav-bar__text{
        color: #018fe0;
    }

</style>